import React, { useRef, useState, useEffect } from 'react';
import { toast } from 'react-toastify'; import { useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import {
  Card,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Table
} from "reactstrap";
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ErrorModal from '../../constants/ErrorModal';
import SpinnerLoader from '../../constants/SpinnerLoader';



const AddHelperMaster = () => {

  const { user } = useSelector((state) => state.authState);
  const location = useLocation();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState('');
  let initial = {
    form_name: '',
    field_name: "",
    field_data: "",
    vendor_master_id: null,
    branch_master_id: null,
    system_generate: user.user_profile == "superadmin" ? "yes" : "no",
    display_option: "yes",
  }

  const [helperData, setHelperData] = useState(initial);
  const [editMode, setEditMode] = useState(false);
  const [helperFlagMasterTable, setHelperFlagMasterTable] = useState([]);
  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });



  const onHandleBackFilter = () => {
    navigate(-1)
  }

  const onChangeHandle = (e) => {
    const { name, value, type } = e.target;
    setHelperData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  //vali
  const validateInputs = () => {
    const errors = {};

    if (!helperData.vendor_master_id) {
      errors.vendor_master_id = 'Vendor is required';
    }

    if (!helperData.branch_master_id) {
      errors.branch_master_id = 'Branch is required';
    }

    if (!helperData.form_name) {
      errors.form_name = 'From Name is required';
    }

    if (!helperData.field_name) {
      errors.field_name = 'Field Name is required';
    }

    if (!helperData.field_data) {
      errors.field_data = 'Field Data is required';
    }

    if (!helperData.display_option) {
      errors.display_option = 'Display  is required';
    }

    if (user.user_profile != "superadmin" && !helperData.working_bussinesss_mode) {
      errors.working_bussinesss_mode = "Working Business is required"
    }


    return errors;
  };

  const AddHelperData = async () => {


    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true)
      setIsSubmitting(false);

      return;
    } else {
      setErrorMessage("")
    }


    try {

      let config = {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        }
      };

      const response = await apiService.post(`/api/HelperMaster/create`, helperData, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        navigate("/helperMaster");
        setHelperData(initial)
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const getHelperData = async (helperId) => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperMaster/detailById?helperId=${helperId}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        setHelperData(response.helperMasterByID)
        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  const updateHelperData = async () => {

    // If already submitting, do nothing
    if (isSubmitting) {
      return;
    }
    setIsSubmitting(true);

    const errors = validateInputs();
    if (Object.keys(errors).length > 0) {
      setErrorMessage(errors);
      setShowErrorModal(true)
      setIsSubmitting(false);

      return;
    } else {
      setErrorMessage("")
    }


    try {

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.put(`/api/HelperMaster/update?helperId=${helperData.id}`, helperData, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message)
        navigate("/helperMaster");

      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  }


  useEffect(() => {
    if (location.state) {
      getHelperData(location.state.helperId);
      setEditMode(true)
    }
  }, [location.state]);


  const getHelperFlagMasterData = async (page = 1, limit = 10000000, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperFlagMaster/allHelperFlag?pageNo=${page}&limit=${limit}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        console.log(response.categoryMasterDetailData)
        setHelperFlagMasterTable(response.helperFlagMasterData)
        // setTotalPage(response.totalPages)
        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    }
  };

  useEffect(() => {
    getHelperFlagMasterData();
  }, [!helperFlagMasterTable]);



  const [helperMasterWorkBussinessTable, setHelperMasterWorkBussinessTable] = useState([]);

  const getHelperMasterData = async (formName, setStateCallback) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/HelperMaster/allOption?fromName=${formName}`, config);

      if (response?.response?.data?.errors) {
        toast.success(response.response.data.errors);
        return;
      }

      if (response?.status === true) {
        setStateCallback(response.helperMasterData);
      } else {
        toast.success(response?.message || "Unknown error occurred");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong!!");
    }
  };

  useEffect(() => {
    getHelperMasterData("working_bussinesss_mode", setHelperMasterWorkBussinessTable);
  }, []);


  const getVendorName = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.get(`/api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        // console.log(response.CompanyMasterMasterData)
        if (response.venderMasterData.length == 1 && response.venderMasterData) {

          setVenderMasterTable(response.venderMasterData)
          setHelperData((prevDetails) => ({
            ...prevDetails,
            vendor_master_id: response.venderMasterData[0].id,
          }));

        }
        else {
          setVenderMasterTable(response.venderMasterData)
        }
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading(prev => ({ ...prev, vender: false }));
    }
  };

  const getBranchMasterData = async (page = 1, limit = 10, search = "") => {
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const filterName = helperData.vendor_master_id ? helperData.vendor_master_id : null;

      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;
      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }


      const response = await apiService.get(`/api/BranchMaster/all?${queryString}`, config);
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {

        if (response.branchMasterData.length == 1 && response.branchMasterData) {

          setBranchMasterTable(response.branchMasterData)
          setHelperData((prevDetails) => ({
            ...prevDetails,
            branch_master_id: response.branchMasterData[0].id,
          }));

        }
        else {
          setBranchMasterTable(response.branchMasterData)
          // setHelperData((prevDetails) => ({
          //   ...prevDetails,
          //   branch_master_id: null
          // }));
        }

        // toast.success(response.message);
      }
      else {
        toast.success(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setPageLoading(prev => ({ ...prev, branch: false }));
    }
  };

  useEffect(() => {
    getVendorName();
    getBranchMasterData();
  }, [helperData?.vendor_master_id])


  useEffect(() => {

    const allApisLoaded = Object.values(pageloading).every(status => status === false);
    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.party_branch_vendor_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.party_branch_master_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
      setShowErrorModal(true);
    } else {
      setErrorMessage({});
      setShowErrorModal(false);
    }
  }, [branchMaster, venderMaster, pageloading]);



  if (Object.values(pageloading).some(status => status == true)) {
    return <SpinnerLoader />
  }

  return (
    <>
      <Row>
        <Col>
          <Card className='bg-white pd-10 card-box mb-30'>
            <CardTitle tag="h6" className="border-bottom p-3 mb-0 d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <i className="bi bi-bell mr-2"></i>
                {editMode ?
                  <p>
                    Edit Helper Master
                  </p> :
                  <p> Helper Master </p>}
              </div>

              <Button color="warning" size="bg" onClick={onHandleBackFilter} className="ml-auto">
                Back
              </Button>
            </CardTitle>
            <CardBody>
              <Form>
                <Row>

                  <Col xl={12}>
                    {(venderMaster.length === 0 || venderMaster.length > 1) && <FormGroup>
                      <Label for="vendor_master_id">Vendor Name</Label>
                      <Input 
                        type='select'  className="custom-select"
                        id="vendor_master_id"
                        name="vendor_master_id"
                        value={helperData.vendor_master_id}
                        onChange={onChangeHandle}
                      >
                        <option value="">Select</option>
                        {venderMaster.map((option) => (
                          <option key={option.id} value={option.id} data-id={option.id}>
                            {option.vender_name}
                          </option>
                        ))}
                      </Input>
                      {errorMessage.vendor_master_id && (
                        <FormText color="danger">{errorMessage.vendor_master_id}</FormText>
                      )}
                    </FormGroup>}
                  </Col>

                  <Col xl={12}>


                    {(branchMaster.length === 0 || branchMaster.length > 1) &&
                      <FormGroup>
                        <Label for="branch_master_id">Branch Name</Label>
                        <Input 
                          type='select'  className="custom-select"
                          id="branch_master_id"
                          name="branch_master_id"
                          value={helperData.branch_master_id}
                          onChange={onChangeHandle}
                        >
                          <option value="">Select</option>
                          {branchMaster.map((option) => (
                            <option key={option.id} value={option.id} data-id={option.id}>
                              {option.branch_name}
                            </option>
                          ))}
                        </Input>
                        {errorMessage.branch_master_id && (
                          <FormText color="danger">{errorMessage.branch_master_id}</FormText>
                        )}
                      </FormGroup>}
                  </Col>
                </Row>


                <Row>
                  <Col md-3 xl={6}>
                    <FormGroup>
                      <Label for="from_name" >Flag</Label>

                      <Input 
                        id="form_name"
                        name="form_name"
                        onChange={(e) => { onChangeHandle(e) }}
                        value={helperData?.form_name}
                        // placeholder="Ent Filteer ar"
                        type="select"  className="custom-select"
                      >
                        <option value="">Select</option>
                        {
                          helperFlagMasterTable.map((data) => (
                            <option value={data.helper_flag_name}>{data.helper_flag_name}</option>
                          ))
                        }

                      </Input>


                      {errorMessage.form_name && (
                        <FormText color="danger">{errorMessage.form_name}</FormText>
                      )}
                    </FormGroup>

                  </Col>
                  <Col xl={6}>
                    <Label for="field_name">Label Detail</Label>
                    <Input 
                      type="text"
                      name="field_name"
                      id="field_name"
                      onChange={(e) => { onChangeHandle(e) }}
                      value={helperData?.field_name}
                    />

                    {errorMessage.field_name && (
                      <FormText color="danger">{errorMessage.field_name}</FormText>
                    )}
                  </Col>



                  <Col xl={6}>
                    <Label for="field_data">Value Data</Label>
                    <Input 
                      type="text"
                      name="field_data"
                      id="field_data"
                      value={helperData.field_data}
                      onChange={(e) => { onChangeHandle(e) }}
                    />

                    {errorMessage.field_data && (
                      <FormText color="danger">{errorMessage.field_data}</FormText>
                    )}
                  </Col>

                  <Col xl={6}>
                    <Label for="display_option">Display Option</Label>
                    <Input 
                      type="select"  className="custom-select"
                      name="display_option"
                      id="display_option"
                      value={helperData.display_option}
                      onChange={(e) => { onChangeHandle(e) }}
                    >
                      <option value="">Select</option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </Input>

                    {errorMessage.display_option && (
                      <FormText color="danger">{errorMessage.display_option}</FormText>
                    )}
                  </Col>



                  {user.user_profile == "superadmin" &&
                    <Col xl={6}>
                      <Label for="working_bussinesss_mode">Working Business Option</Label>
                      <Input 
                        type="select"  className="custom-select"
                        name="working_bussinesss_mode"
                        id="working_bussinesss_mode"
                        value={helperData.working_bussinesss_mode}
                        onChange={(e) => { onChangeHandle(e) }}
                      >
                        <option value="">Select</option>
                        {helperMasterWorkBussinessTable.map((option) => (
                          <option key={option.id} value={option.field_data}>
                            {option.field_name}
                          </option>
                        ))}
                      </Input>

                      {errorMessage.working_bussinesss_mode && (
                        <FormText color="danger">{errorMessage.working_bussinesss_mode}</FormText>
                      )}
                    </Col>}
                </Row>


                {editMode ?
                  <Button type="button" className="mt-2" color="primary" disabled={isSubmitting} onClick={() => updateHelperData()}>Update</Button>
                  :
                  <Button type="button" className="mt-2" color="primary" disabled={isSubmitting} onClick={() => AddHelperData()}>Save</Button>
                }

              </Form>
            </CardBody>



            {/* Error Model */}

            <ErrorModal
              show={showErrorModal}
              title="Validation / Action Required"
              content={errorMessage}
              condition={true}
              onCancel={() => setShowErrorModal(false)}
            // onConfirm={true}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default AddHelperMaster;

